var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99951 12.4037C5.70818 12.403 3.61951 10.7743 2.37951 8.035C3.61951 5.29634 5.70884 3.66767 7.99951 3.667C10.2908 3.66767 12.3795 5.29634 13.6195 8.035C12.3795 10.7743 10.2908 12.403 7.99951 12.4037ZM7.99818 13.4037H8.00084H8.00151C10.7588 13.4017 13.2355 11.469 14.6255 8.23234C14.6802 8.10634 14.6802 7.96367 14.6255 7.83767C13.2348 4.60167 10.7588 2.669 8.00151 2.667C8.00123 2.66673 8.00107 2.66657 8.00088 2.66652C8.00061 2.66645 8.00029 2.66661 7.99951 2.667C7.99884 2.66634 7.99884 2.66634 7.99751 2.667C5.24084 2.669 2.76417 4.60167 1.37351 7.83767C1.31951 7.96367 1.31951 8.10634 1.37351 8.23234C2.76417 11.469 5.24017 13.4017 7.99751 13.4037H7.99818ZM6.39197 8.03554C6.39197 7.14887 7.11264 6.42754 7.99931 6.42754C8.88597 6.42754 9.60731 7.14887 9.60731 8.03554C9.60731 8.92154 8.88597 9.6422 7.99931 9.6422C7.11264 9.6422 6.39197 8.92154 6.39197 8.03554ZM5.39197 8.03554C5.39197 9.47287 6.56131 10.6422 7.99931 10.6422C9.43731 10.6422 10.6073 9.47287 10.6073 8.03554C10.6073 6.59754 9.43731 5.42754 7.99931 5.42754C6.56131 5.42754 5.39197 6.59754 5.39197 8.03554Z",
    fill: "#43454C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.da8f830d.svg";
export { ForwardRef as ReactComponent };